import React from 'react'
import FindALeague from '../components/FindALeague/FindALeague'

function FindALeaguePage(props) {
    return (
        <FindALeague></FindALeague>
    )
}


export default FindALeaguePage
